"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _itemContainer = _interopRequireDefault(require("../item/itemContainer.js"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var GroupView =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(GroupView, _React$Component);

  function GroupView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.displayName = 'GroupView';
    _this.dom = [];
    _this.state = {};
    return _this;
  }

  var _proto = GroupView.prototype;

  _proto.createDom = function createDom(visible) {
    var _this2 = this;

    return this.props.items.map(function (item) {
      return _react["default"].createElement(_itemContainer["default"], _lodash["default"].merge(item.renderProps(_lodash["default"].merge(_this2.props.galleryConfig, {
        visible: visible
      })), {
        store: _this2.props.store
      }));
    });
  };

  _proto.render = function render() {
    var groupStyle = {
      width: this.props.width,
      height: this.props.totalHeight
    };
    return _react["default"].createElement("div", {
      key: "group_" + this.props.idx,
      "data-hook": 'group-view'
    }, this.createDom(true));
  };

  return GroupView;
}(_react["default"].Component);

var _default = GroupView;
exports["default"] = _default;